import GoogleMap from 'src/components/etc/GoogleMap/index'
import { RootState } from 'src/store/store'
import Div from 'src/components/atomic/atom/Div'
import ImageDetail from 'src/components/atomic/Molecules/ImageDetail'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'

const LocationDetailTemplate = () => {
  const { LocationInfos } = useAppSelector((state: RootState) => state.locationHistory)
  const { imageDetailFlag, selectPin } = useAppSelector((state: RootState) => state.LocationPage)

  const LocationDetailWrapStyle = {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    margin: '0 auto',
  }

  return (
    <>
      <Div style={LocationDetailWrapStyle}> {LocationInfos?.length > 0 && <GoogleMap />}</Div>
      {imageDetailFlag && selectPin && <ImageDetail />}
    </>
  )
}
export default LocationDetailTemplate
